import { Redirect, Navigate , useNavigate , Outlet} from 'react-router-dom';
import { useDispatch,  useSelector} from 'react-redux';

export const ProtectedRoute = () => {
  const navigate = useNavigate()
  const auth_reducer = useSelector((state) => { return state.authReducer })
  return (
    <>
    { auth_reducer.is_logged_in ? <Outlet/> :  <Navigate to='/auth/login' /> }
    </>
  )
};
